/**
 * the DOMContentLoaded handler runs when the document is loaded, so it can see all the elements, including <img> below.
 * But it doesn’t wait for the image to load. So alert shows zero sizes.
 */
function avvioMenu() {
	/**
	 * Hamburger menu toggle active class and toggle the aria-expanded attr
	 */

	let avvioMenuHamburger = document.querySelector('.avvio-header__hamburger');
	let avvioHeader = document.querySelector('.avvio-header');
	let avvioHeaderMenu = document.querySelector('.avvio-header__menu');
	let headerHeight = avvioHeader.offsetHeight;
	let avvioCookiePreference = document.querySelector('.avvio-footer__menu .avvio-footer__menu-item a[href$="/acc-cookies-panel-trigger/"], a[href*="acc-cookies-panel-trigger"]');

	// document.querySelector('body').style.paddingTop = `${headerHeight}px`;

	if (typeof (avvioMenuHamburger) != 'undefined' && avvioMenuHamburger != null) {
		avvioMenuHamburger.addEventListener('click', avvioToggleMenu);
		function avvioToggleMenu(el) {

			if (typeof (avvioHeaderMenu) != 'undefined' && avvioHeaderMenu != null) {
				if (avvioMenuHamburger.classList.contains('avvio-header__hamburger--is-active')) {
					avvioMenuHamburger.classList.remove('avvio-header__hamburger--is-active');
					avvioMenuHamburger.setAttribute('aria-expanded', 'false');

					avvioHeader.classList.remove('avvio-header__menu--visible');
					setTimeout(function () {
						avvioHeaderMenu.removeAttribute('style');
					}, 1000);
				}
				else {
					avvioMenuHamburger.classList.add('avvio-header__hamburger--is-active');
					avvioMenuHamburger.setAttribute('aria-expanded', 'true');
					avvioHeader.classList.add('avvio-header__menu--visible');
					avvioHeaderMenu.style.setProperty('height', `calc(100vh - 0px)`);
				}
			}
		}

		// Reset the menu stuff if the window is resizes and the menu is active
		window.addEventListener('resize', function () {
			setTimeout(function () {
				avvioMenuHamburger.setAttribute('aria-expanded', 'false');
				avvioMenuHamburger.classList.remove('avvio-header__hamburger--is-active');

				avvioHeaderMenu.classList.remove('avvio-header__menu--visible');
				avvioHeaderMenu.removeAttribute('style');


				let avvioSubMenuElement = document.querySelectorAll('.avvio-header__menu-item-has-children');
				for (let menuItem = 0; menuItem < avvioSubMenuElement.length; menuItem++) {
					// Grab the anchor tag within the sub-menu
					let targetAnchor = avvioSubMenuElement[menuItem];

					targetAnchor.classList.remove('avvio-header__submenu--open');
					targetAnchor.classList.add('avvio-header__submenu--closed');

					let subMenu = targetAnchor.lastElementChild;
					subMenu.classList.remove('avvio-header__submenu--expanded');
					subMenu.removeAttribute('style');
				}

			}, 300);
		});

		document.addEventListener('click', function (event) {
			if (event.target.matches('.avvio-header__hamburger')) {
				let avvioSubMenuElement = document.querySelectorAll('.avvio-header__menu-item-has-children');
				for (let menuItem = 0; menuItem < avvioSubMenuElement.length; menuItem++) {
					// Grab the anchor tag within the sub-menu
					let targetAnchor = avvioSubMenuElement[menuItem].firstElementChild;
					// TargetAnchor the click on the link
					// targetAnchor.addEventListener('click', avvioSubMenu);
					// Click on the Chevron
					let targetChevron = targetAnchor.nextElementSibling;
					targetChevron.addEventListener('click', avvioSubMenu);
				}
			}
		}, false);


		// Add class to header when docuemnt is scrolled past 100px
		window.addEventListener('scroll', function (e) {

			if (window.scrollY > headerHeight) {
				avvioHeader.classList.add('avvio-header--small');
				document.querySelector('body').classList.add('body--on-scroll');
			}
			else {
				avvioHeader.classList.remove('avvio-header--small');
				document.querySelector('body').classList.remove('body--on-scroll');
			}

		});


		// Get the sub menus
		function avvioSubMenu(el) {

			// some code to execute
		}
	}
	// Avvio cookie consent tool settings hook
	if (document.body.contains(avvioCookiePreference)) {
		avvioCookiePreference.addEventListener('click', function (e) {
			e.preventDefault();
			if (typeof AvvioCC !== 'undefined') AvvioCC.showMoreDetails();
		});
	}


};

/**
 * Run the menu script only on the front end
 */
//let avvioVoyagerFrontEnd = document.body.querySelector('.avvio-voyager');
let avvioVoyagerFrontEnd = document.querySelector('.avvio-voyager');
if (typeof (avvioVoyagerFrontEnd) != 'undefined' && avvioVoyagerFrontEnd != null) {
	document.addEventListener("DOMContentLoaded", avvioMenu());
}